import CadastrosEstoqueView from "../../components/estoque/CadastrosEstoqueView";

export default function CadastrosEstoque() {
  return <CadastrosEstoqueView />;
}
